import { styled } from '@mui/system'
import { Box, FormControlLabel } from '@mui/material'

export const FormLabel = styled('span')(`
  font-style: normal;
  font-weight: 400;
  font-size: 14px;
  line-height: 19px;
  color: #000;
  width:100%;
`)

export const FormControlLabelWrap = styled(FormControlLabel)(`
  & .MuiFormControlLabel-label {
    font-size : 14px;
  }
`)

export const FormError = styled(Box)(`
  font-size: 0.75rem;
  font-weight: 400;
  margin: 4px 14px 0 14px;
  color: #D14343;
`)

export const RadioGroupWrap = styled('label')(`
  display: flex;
  flex-direction: row;
  align-items: center;
  padding-bottom:10px;
  font-size: 14px;
  font-weight:normal;
  
  & > span {
    padding:0 10px 0 0;
  }
  & svg {
    margin-left:0;
  }

  &.themeV2{
    padding-bottom: 0px;
    font-size: 20px;
  }
  &.themeV2 .MuiRadio-root,
  & .themeV2.MuiRadio-root {
    color: #095BBD;
    transform: scale(1.3); 
  }

  &.themeV2 .MuiRadio-root.Mui-checked,
  & .themeV2.MuiRadio-root.Mui-checked {
    color: #095BBD; 
  }

  &.themeV2 .MuiFormControlLabel-label {
    font-size : 14px;
  }
`)

export const CustomRadioIcon = styled('span')({
  width: 20,
  height: 20,
  borderRadius: '50%',
  border: '1px solid #095BBD',
  backgroundColor: 'transparent',
  display: 'inline-block',
})

export const CustomRadioCheckedIcon = styled(CustomRadioIcon)({
  backgroundColor: '#095BBD',
  boxShadow: 'inset 0 0 0 3px #E6F0FA',
})
